/*
 * THIS CLASS IS AUTOGENERATED
 * Please do not edit this file manually. Use the client generation tool instead.
 */

// tslint:disable
/* eslint-disable */
import { inject, Injectable } from "@angular/core";
import { HttpRequestMethod, HttpService, UrlProvider } from "@vega/http";
import { LoggerFactory } from "@vega/logging";
import { ResponseErrorHandler } from "@vega/readdataaccess";
import { defer, Observable } from "rxjs";
import { BusinessResultItemResponse, ErrorMessageResponse, TransactionResponse } from "./../model";

@Injectable({
    providedIn: "root"
})
export class TransactionClient {
    private _urlProvider = inject(UrlProvider);
    private _httpService = inject(HttpService);
    private _responseErrorHandler = inject(ResponseErrorHandler);
    private _logger = inject(LoggerFactory).getLogger("TransactionClient");

    /**
     * Get Transactions between dates
     * Represents the controller method
     * /api/{mandator}/{culture}/Transaction
     * @param culture
     * @param mandator
     * @param startDate
     * @param endDate
     * @param limit
     * @param lastPayoutId
     */
    public getTransactionsInformation(
        culture: string,
        mandator: string,
        startDate: string | undefined,
        endDate: string | undefined,
        limit: number | undefined,
        lastPayoutId: string | undefined
    ): Observable<BusinessResultItemResponse<TransactionResponse>> {
        return new Observable<BusinessResultItemResponse<TransactionResponse>>((observer) => {
            this._logger.debug(`Get Transactions between dates with parameters:`, [
                culture,
                mandator,
                startDate,
                endDate,
                limit,
                lastPayoutId
            ]);

            const options = { endDate, lastPayoutId, limit, startDate };
            const url = this._urlProvider.create([
                encodeURIComponent(String(mandator)),
                encodeURIComponent(String(culture)),
                "Transaction"
            ]);
            const abortController = new AbortController();

            this._logger.debug(`Generated url:`, [url]);

            this._logger.debug("Get data with the options:", options);
            const request = this._httpService.getAsync(url, options, abortController);

            let response: Response | undefined;
            request
                .then((r) => {
                    response = r;
                    return this._responseErrorHandler.processPossibleErrorsAsync(response, HttpRequestMethod.Get);
                })
                .then(() => response!.json())

                .then((jsonResponse) => {
                    observer.next(jsonResponse as BusinessResultItemResponse<TransactionResponse>);
                    observer.complete();
                })
                .catch((error) => {
                    this._logger.warning(`Get Transactions between dates An unexpected error occurred:`, error);
                    observer.error(error);
                });
            return () => {
                if (!response) {
                    this._logger.debug(`Aborting running request to Url: ${url}`);
                    abortController.abort();
                }
            };
        });
    }
}
